<template>
	<Space>
		<template v-if="!roverRef.deleted">
			<Button
				v-if="action === 'stop'"
				class="stop-button"
				@click="onStatusChange(roverRef.id, 'stop')"
			>
				{{ $t('roverActionBar.stop') }}
			</Button>
			<Button
				v-else-if="action === 'start'"
				class="start-button"
				@click="onStatusChange(roverRef.id, 'start')"
			>
				{{ $t('roverActionBar.start') }}
			</Button>
			<Button v-else-if="action === 'processing'" disabled>{{ $t('roverActionBar.processing') }}</Button>

			<Button @click="onStatusChange(roverRef.id, 'delete')">{{ $t('roverActionBar.delete') }}</Button>
		</template>

		<Button type="primary" v-else @click="onStatusChange(roverRef.id, 'restore')">{{ $t('roverActionBar.restore') }}</Button>
	</Space>
</template>

<script>
import { toRef, computed } from 'vue';

import { Button, Space } from 'ant-design-vue';

import { useRoversStore } from '@/stores/rovers';

import Consts from '@/api/Consts';

const STATUSES = {
	'updating': 'processing',
	'invalid': null,
	'verification': 'processing',
	'stopped': 'start',
	'working': 'stop',
	'deleted': null,
}

export default {
	components: {
		Button, Space,
	},
	props: {
		rover: {
			type: Object,
			required: true,
		},
	},
	setup(props) {
		const roverRef = toRef(props, 'rover');
		const action = computed(() => STATUSES[roverRef.value.display_status]);
		const roversStore = useRoversStore();

		return {
			roverRef,
			action,
			onStatusChange: roversStore.changeRoverStatus,

			colorSuccess: Consts.COLORS.success,
			colorSuccessLight: Consts.COLORS.successLight,
			colorSuccessUltraLight: Consts.COLORS.successUltraLight,
			colorSuccessUltraDark: Consts.COLORS.successUltraDark,
			colorError: Consts.COLORS.error,
			colorErrorLight: Consts.COLORS.errorLight,
			colorErrorUltraLight: Consts.COLORS.errorUltraLight,
			colorErrorUltraDark: Consts.COLORS.errorUltraDark,
		}
	}
}
</script>

<style scoped>
.stop-button {
	background-color: v-bind(colorErrorUltraLight);
	border-color: v-bind(colorErrorLight);
	color: v-bind(colorErrorUltraDark);
}

.stop-button:hover,
.stop-button:focus {
	background-color: v-bind(colorErrorLight);
	border-color: v-bind(colorError);
	color: v-bind(colorErrorUltraDark);
}

.start-button {
	background-color: v-bind(colorSuccessUltraLight);
	border-color: v-bind(colorSuccessLight);
	color: v-bind(colorSuccessUltraDark);
}

.start-button:hover,
.start-button:focus {
	background-color: v-bind(colorSuccessLight);
	border-color: v-bind(colorSuccess);
	color: v-bind(colorSuccessUltraDark);
}
</style>
